export function getPlatform() {
    const ua = navigator.userAgent
    const isIOS = /iPad|iPhone|iPod/.test(ua)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    const isAndroid = /Android/i.test(ua)
    if (isIOS) return 'ios'
    if (isAndroid) return 'android'
    return 'other'
  }